module.exports = __webpack_public_path__ + "img/chooseGreen.df04a961.png";